import axios from 'axios'
import PropTypes from 'prop-types'

const NAME = 'client'

const ClientShape = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.instanceOf(axios.Axios)
])

export {
  NAME,
  ClientShape
}
